// Display names for ClientFeatureFlag values. A flag missing here falls back to its enum name.
export const FEATURE_FLAG_LABELS = {
    REPUTATIONAL_AI_AGENT: 'Reputational AI Agent',
    TIN_VERIFICATION: 'TIN Verification',
    MOTUS: 'Motus',
    SAMGOV: 'SAM.gov',
    NPPES: 'NPPES',
    LEIE: 'HHS OIG Exclusions (LEIE)',
    OFAC: 'OFAC Sanctions',
    STATE_MEDICAID: 'State Medicaid Exclusions',
    TAXROCK: 'TaxRock Business Tax',
    BANK_DOC_ANALYSIS: 'Bank Document Analysis',
    BALANCE_SHEET_ANALYSIS: 'Balance Sheet Analysis',
    INCOME_STATEMENT_ANALYSIS: 'Income Statement Analysis',
    CASH_FLOW_STATEMENT_ANALYSIS: 'Cash Flow Statement Analysis',
    DSCR_ANALYSIS: 'DSCR Analysis',
    HEALTHCARE_SEARCH: 'Healthcare Search',
    MONITORING_ADVANCED: 'Advanced Monitoring',
    MONITORING_ALERT_EMAILS: 'Monitoring Alert Emails',
    MONITORING_BELL_NOTIFICATIONS: 'Monitoring Bell Notifications',
    NEW_APPLICATION_DETAIL: 'New Application Detail',
    TWO_FACTOR_REQUIRED: 'Two-Factor Authentication Required',
    CREDIT_MEMO_APPROVAL: 'Credit Memo Approval',
    APPLICATION_EXPORT: 'Application Export',
    APPLICATION_DECLINE_EMAIL: 'Application Decline Email',
    SALES_REP_USERS: 'Sales Rep Users',
    SALES_REP_NOTE_EMAILS: 'Sales Rep Note Emails',
    APPLICATION_FLAGGING: 'Application Flagging',
    APPLICATION_EMAIL_STEPS: 'Steps in Application Emails',
};

export const featureFlagLabel = (flag) => FEATURE_FLAG_LABELS[flag] || flag;

// Groups for the flag lists, in display order. A flag missing here goes under "Other".
export const FEATURE_FLAG_CATEGORIES = ['Client portal', 'Data sources', 'Applications', 'Monitoring', 'Users & security', 'Other'];

const FEATURE_FLAG_CATEGORY = {
    APPLICATION_EMAIL_STEPS: 'Client portal',
    REPUTATIONAL_AI_AGENT: 'Data sources',
    TIN_VERIFICATION: 'Data sources',
    MOTUS: 'Data sources',
    SAMGOV: 'Data sources',
    NPPES: 'Data sources',
    LEIE: 'Data sources',
    OFAC: 'Data sources',
    STATE_MEDICAID: 'Data sources',
    TAXROCK: 'Data sources',
    HEALTHCARE_SEARCH: 'Data sources',
    BANK_DOC_ANALYSIS: 'Applications',
    BALANCE_SHEET_ANALYSIS: 'Applications',
    INCOME_STATEMENT_ANALYSIS: 'Applications',
    CASH_FLOW_STATEMENT_ANALYSIS: 'Applications',
    DSCR_ANALYSIS: 'Applications',
    NEW_APPLICATION_DETAIL: 'Applications',
    CREDIT_MEMO_APPROVAL: 'Applications',
    APPLICATION_EXPORT: 'Applications',
    APPLICATION_DECLINE_EMAIL: 'Applications',
    APPLICATION_FLAGGING: 'Applications',
    SALES_REP_NOTE_EMAILS: 'Applications',
    MONITORING_ADVANCED: 'Monitoring',
    MONITORING_ALERT_EMAILS: 'Monitoring',
    MONITORING_BELL_NOTIFICATIONS: 'Monitoring',
    TWO_FACTOR_REQUIRED: 'Users & security',
    SALES_REP_USERS: 'Users & security',
};

export const featureFlagCategory = (flag) => FEATURE_FLAG_CATEGORY[flag] || 'Other';

// Sort by category (in FEATURE_FLAG_CATEGORIES order), then by label
export const compareFeatureFlags = (a, b) =>
    FEATURE_FLAG_CATEGORIES.indexOf(featureFlagCategory(a)) - FEATURE_FLAG_CATEGORIES.indexOf(featureFlagCategory(b))
    || featureFlagLabel(a).localeCompare(featureFlagLabel(b));
